<template>
  <b-modal
    ref="modal"
    size="xl"
    class="text-left job-offer-modal"
    centered
    footer-class="justify-content-center"
    :visible="visible"
    ok-only
    ok-title="Close"
    @hidden="onModalHidden"
    hide-footer
  >
    <template slot="modal-header">
      <div class="w-100">
        <h5
          class="modal-title v2_info-popup__title text-center v3_color_teal mt-2"
        >
          Job Offer Preview
        </h5>
      </div>
    </template>
    <div class="p-4">
      <h3 class="v2_info-popup__title mb-1 v3_color_teal">
        Job Offer Details:
      </h3>
      <div class="border_1 v3_color_teal p-2 mb-3">
        <ico-browser-criteria-results :criteria-items="criteriaItems" />
      </div>

      <div class="d-none">
        <h3 class="v2_info-popup__title mb-2 v3_color_teal">
          Candidate filters:
        </h3>
        <b-row class="px-5">
          <b-col md="3">
            <h3
              class="v2_info-popup__title font-job-offer-detail mb-2 v3_color_teal"
            >
              Board Certified:
              <span class="cand-text ml-2">{{ board_certified }}</span>
            </h3>
            <h3
              class="v2_info-popup__title font-job-offer-detail mb-1 v3_color_teal"
            >
              Visa Status: <span class="cand-text ml-2">{{ visa_status }}</span>
            </h3>
          </b-col>
          <b-col md="6" class="text-center">
            <h3 class="v2_info-popup__title mb-3 v3_color_teal">
              Number of Profile Matches
            </h3>
            <span class="border_1 py-2 px-4 v3_color_teal profile-matches-number">
            {{ numberOfMatches }}
          </span>
          </b-col>
        </b-row>
      </div>
      <div class="d-flex justify-content-center mt-5">
        <b-button
          variant="v3_teal_outline"
          class="v3_color_teal"
          @click="onContinue"
        >
          Continue
        </b-button>
        <b-button
          variant="v3_teal_outline"
          class="v3_color_teal ml-3"
          @click="onCancel"
        >
          Cancel
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import IcoBrowserCriteriaResults from '@/components/pre-paywall-pages/recruiter/IcoBrowserCriteriaResults';

export default {
  name: 'JobOfferPreviewModal',
  components: {
    IcoBrowserCriteriaResults,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    criteriaItems: {
      type: Array,
      required: true,
    },
    numberOfMatches: {
      default: '-',
    },
  },
  data: function () {
    return {
      board_certified: 'Yes',
      visa_status: 'US Citizen',
    };
  },
  computed: {},
  methods: {
    onModalHidden: function () {
      this.$emit('modal-close');
    },
    onContinue: function () {
      this.$emit('continue');
    },
    onCancel: function () {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.font-job-offer-detail {
  font-size: 16px !important;
}
.cand-text {
  font-weight: normal;
}
.profile-matches-number {
  font-size: 24px;
  font-weight: 700;
  background-color: #aeccd3;
}
</style>
<style>
.job-offer-modal .modal-header,
.job-offer-modal .modal-footer {
  border: 0 !important;
}
</style>
